var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFikaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 0C22.1262 0 24.8125 2.68629 24.8125 6V18C24.8125 21.3137 22.1262 24 18.8125 24H6.8125C3.49879 24 0.8125 21.3137 0.8125 18V6C0.8125 2.68629 3.49879 0 6.8125 0H18.8125Z",
    fill: "#51778C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3403 5.46094H5.13842C4.95878 5.46094 4.8125 5.61064 4.8125 5.79541V20.1966C4.8125 20.3814 4.95792 20.5311 5.13842 20.5311H7.59437C7.77401 20.5311 7.92029 20.3814 7.92029 20.1966V14.4875H17.8732C18.1341 14.4875 18.3454 14.2702 18.3454 14.0033V11.9562C18.3454 11.7047 18.1581 11.5003 17.9194 11.4763V11.4652H7.92029V8.47719H20.3403C20.6012 8.47719 20.8125 8.25991 20.8125 7.99302V5.94511C20.8125 5.67736 20.6012 5.46094 20.3403 5.46094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFikaIcon);
export default __webpack_public_path__ + "static/media/fika-icon.3afc70a072aa69926c3b4ddb5933cbf3.svg";
export { ForwardRef as ReactComponent };